import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React, {useEffect, useState} from "react";
import {focusedVehicleSelector, focusVehicle, isMobileSelector, VehicleDetails} from "../../chatbotSlice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {VehicleCard} from "./VehicleCard";
import {VehicleSliderLeftIcon} from "./VehicleSliderLeftIcon";
import {VehicleSliderRightIcon} from "./VehicleSliderRightIcon";

interface VehicleSliderProps {
    vehicles: VehicleDetails[]
}

export const VehicleSlider: React.FC<VehicleSliderProps> = ({vehicles}) => {

    const dispatch = useAppDispatch();
    const focusedVehicle = useAppSelector(focusedVehicleSelector);
    const isMobile = useAppSelector(isMobileSelector);

    function getInitialSlideIndex() {
        if (focusedVehicle && vehicles.findIndex(v => v.vin == focusedVehicle) != -1) {
            return vehicles.findIndex(v => v.vin == focusedVehicle)
        }
        return 0;
    }

    const initialSlideIndex = getInitialSlideIndex();

    const [currentVehicleIndex, setCurrentVehicleIndex] = useState(initialSlideIndex);

    useEffect(() => {
        setFocusVehicle(vehicles[currentVehicleIndex].vin)
    }, [vehicles, currentVehicleIndex])

    const setFocusVehicle = (value: string) => {
        dispatch(focusVehicle({VIN: value}))
    };

    return <div className="w-full relative">
        {!isMobile && (
            <>
                <div className="absolute top-1/2 left-2 transform -translate-y-1/2 z-10">
                    <VehicleSliderLeftIcon
                        currentVehicleIndex={currentVehicleIndex}
                        setCurrentVehicleIndex={setCurrentVehicleIndex}
                        vehicles={vehicles}
                    />
                </div>
                <div className="absolute top-1/2 right-2 transform -translate-y-1/2 z-10">
                    <VehicleSliderRightIcon
                        currentVehicleIndex={currentVehicleIndex}
                        setCurrentVehicleIndex={setCurrentVehicleIndex}
                        vehicles={vehicles}
                    />
                </div>
            </>
        )}
        <Carousel
            showThumbs={false}
            dynamicHeight={false}
            selectedItem={currentVehicleIndex}
            showIndicators={false}
            emulateTouch={true}
            showStatus={false}
            showArrows={false}
            preventMovementUntilSwipeScrollTolerance={true}
            swipeScrollTolerance={15}
            centerMode={true}
            centerSlidePercentage={85}
            onChange={(i) => {
                if (!!vehicles.length) {
                    setFocusVehicle(vehicles[i].vin);
                }
                setCurrentVehicleIndex(i);
            }}
        >
            {vehicles.map((item, i) => (
                <VehicleCard vehicle={item} key={item.vin}/>
            ))}
        </Carousel>
    </div>
}
